import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
//import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Checkbox from "@mui/material/Checkbox";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import { Typography, useMediaQuery, Tooltip, TextField, Box, Switch } from "@mui/material";
import { useDispatch,useSelector } from "react-redux";
import { setCGState } from "./customerGroupSetupSlice";
import InfiniteLoader from 'react-window-infinite-loader';
import AutoSizer from 'react-virtualized-auto-sizer';
import { FixedSizeList as List } from 'react-window';
import dayjs from "dayjs";
import Highlighter from "react-highlight-words";

const addBtnText = "Add >";
const addAllBtnText = "Add All >>";
const remBtnText = "< Remove";
const remAllBtnText = "<< Remove All";

function not(a, b) {
   return a.filter((value) => b.indexOf(value) === -1);
}

function intersection(a, b) {
   return a.filter((value) => b.indexOf(value) !== -1);
}

export default function TransferList({
   leftList,
   rightList,
   leftState,
   rightState,
}) {
   const cgState = useSelector((store) => store.customerGroupSetup);
   const { selCustomers, editFromDate, editToDate, createIndDateUpdated } =
      cgState;
   const [checked, setChecked] = useState([]);
   const [left, setLeft] = useState([]);
   const [right, setRight] = useState([]);
   const [countLeft, setCountLeft] = useState(0);
   const [countRight, setCountRight] = useState(0);
   const [isAscByNameLeft, setAscByNameLeft] = useState(false);
   const [isAscByNameRight, setAscByNameRight] = useState(false);
   const [isAscByNumberLeft, setAscByNumberLeft] = useState(false);
   const [isAscByNumberRight, setAscByNumberRight] = useState(false);
   const [selectionStart, setSelectionStart] = useState(null);
   const [startIndex, setStartIndex] = useState(null);
   const leftChecked = intersection(checked, left);
   const rightChecked = intersection(checked, right);
   const [boxWidth,setBoxWidth]=useState(24);
   const [listItemHeight, setlistItemHeight] = useState(46);
   const [assignSearchQuery, setAssignSearchQuery] = useState("");
   const [assignSearchFilterEnabled, setAssignSearchFilterEnabled] = useState(false);
   const switchClass = `custom-switch ${checked ? 'red-thumb red-track' : ''}`;

   const dispatch = useDispatch();

   const getItemNumber = (item) => {
      if (item.hasOwnProperty("id")) {
        return item.sapCustomerNumber ? item.sapCustomerNumber : item.cip;
      } else if (item.hasOwnProperty("productGroupID")) {
        return 0;
      } else if (item.hasOwnProperty("productID")) {
        return item.clientProductCode;
      } else if (item.hasOwnProperty("customerGroupID")) {
        return 0;
      } else if (item.hasOwnProperty("customerID")) {
        return item.sapCustomerNumber;
      }
   };
   const getItemId = (item) => {
      if (item.hasOwnProperty("customerID")) {
         return item.customerID;
      } else if (item.hasOwnProperty("id")) {
         return item.id;
      }
   };
   const getItemText = (item) => {
		if (item.hasOwnProperty("name")) {
			return item.name + (item['parentName'] == undefined || item['type']=='CG' ? '' : (item['parentName'].indexOf(',')> -1) ? ' ( * )' :' ('+ item['parentName'] + ' )' );
		} else if (item.hasOwnProperty("customerGroupName")) {
			return item.customerGroupName;
		} else if (item.hasOwnProperty("customerName")) {         
         return item.customerName + (item['parentName'] == undefined ? '' : (item['parentName'].indexOf(',')> -1) ? ' ( * )' :' ('+ item['parentName'] + ' )' );
            }
	};

   const assignSearchTerms = React.useMemo(
      () =>
         assignSearchQuery
            .split("|")
            .map((t) => t.trim().toLowerCase())
            .filter(Boolean),
      [assignSearchQuery]
   );

   const assignSearchHighlightWords = React.useMemo(
      () =>
         assignSearchQuery
            .split("|")
            .map((t) => t.trim())
            .filter((t) => t.length > 0),
      [assignSearchQuery]
   );

   const rightView = React.useMemo(() => {
      if (!assignSearchFilterEnabled || assignSearchTerms.length === 0) return right;
      return right.filter((item) => {
         const text = (getItemText(item) || "").toLowerCase();
         const num = String(getItemNumber(item) ?? "").toLowerCase();
         return assignSearchTerms.some(
            (term) => text.includes(term) || num.includes(term)
         );
      });
   }, [right, assignSearchTerms, assignSearchFilterEnabled]);

   const displayListForSide = (side) => (side === "left" ? left : rightView);

   const isTab = useMediaQuery("(max-width: 800px)");

   useEffect(() => {
      if (leftList?.length >= 0) {
         setLeft(leftList);
      }
      if (rightList?.length >= 0) {
         setRight(rightList);
      }
   }, [leftList, rightList]);

   useEffect(()=>{
		const updateZoomLevel = () => {
			const zoom = window.devicePixelRatio || 1;
			if(zoom <= 1){
				let l = isTab ? 25 : 28;
				setBoxWidth(l);
            setlistItemHeight(46);
			}else if (zoom > 1 && zoom <= 1.25){
				setBoxWidth(isTab ? 19 : 25.5);
            setlistItemHeight(60);
			}else if (zoom > 1.25 && zoom < 1.5){
				let l = isTab ? 20 : 23.5;
				setBoxWidth(l);
            setlistItemHeight(80);
			}else if (zoom == 1.5){
				setBoxWidth(isTab ? 19.5 : 22);
            setlistItemHeight(110);
			}else if (zoom > 1.5 && zoom <= 2){
				setBoxWidth(isTab ? 18 : 23);
            setlistItemHeight(70);
			}else if( zoom > 2){
				setBoxWidth(isTab ? 90 : 90);
            setlistItemHeight(70);
			}
		}
		updateZoomLevel();
		window.addEventListener('resize', updateZoomLevel);
		return () => {
			window.removeEventListener('resize', updateZoomLevel);
		}
	}, [window.devicePixelRatio, isTab]);

  let clickTimeout = null;

  const handleToggleWithClick = (event, index, item, side) => {
      if (clickTimeout) {
          clearTimeout(clickTimeout);
          clickTimeout = null;
      }
      clickTimeout = setTimeout(() => {
          handleToggle(event, index, item, side); 
      }, 200); 
  };

   useEffect(() => {
      setCountLeft(left.length);
   }, [left]);

   const handleToggle = (event, index, value, side) => {
      if (event.shiftKey && startIndex !== null) {
         const start = Math.min(startIndex, index);
         const end = Math.max(startIndex, index);
         const listForRange = displayListForSide(side);
         const a = JSON.parse(JSON.stringify(listForRange));
         const newSelectedItems = a.slice(start, end + 1);
         //console.log(newSelectedItems);

         const newChecked = [];
         for (let i = 0; i < newSelectedItems.length; i++) {
            const currentIndex = newChecked.findIndex(
               (item) => getItemId(item) === getItemId(newSelectedItems[i])
            );
            let item = [];
            if (side === "left") {
               item = left.find(
                  (item) => getItemId(item) === getItemId(newSelectedItems[i])
               );
            } else {
               item = right.find(
                  (item) => getItemId(item) === getItemId(newSelectedItems[i])
               );
            }

            if (currentIndex === -1) {
               newChecked.push(item);
            } else {
               newChecked.splice(currentIndex, 1);
            }
         }
         setChecked(newChecked);
      } else {
         const currentIndex = checked.indexOf(value);
         //console.log(event);
         const newChecked = [...checked];

         if (currentIndex === -1) {
            newChecked.push(value);
            setStartIndex(index);
         } else {
            newChecked.splice(currentIndex, 1);
            setStartIndex(null);
         }

         setChecked(newChecked);
      }
   };
   const handleMouseDown = (e, index) => {
      e.preventDefault();
      setSelectionStart(index);
   };

   const handleMouseMove = (e, side, index) => {
      if (selectionStart !== null && e.shiftKey) {
         const start = Math.min(selectionStart, index);
         const end = Math.max(selectionStart, index);
         let a = [];
         const listForRange = displayListForSide(side);
         a = JSON.parse(JSON.stringify(listForRange));
         const newSelectedItems = a.slice(start, end + 1);
         //console.log(newSelectedItems);
         if (newSelectedItems.length > 0 && newSelectedItems.length < 10) {
            const newChecked = [];
            for (let i = 0; i < newSelectedItems.length; i++) {
               const currentIndex = newChecked.findIndex(
                  (item) => getItemId(item) === getItemId(newSelectedItems[i])
               );
               let item = [];
               if (side === "left") {
                  item = left.find(
                     (item) =>
                        getItemId(item) === getItemId(newSelectedItems[i])
                  );
               } else {
                  item = right.find(
                     (item) =>
                        getItemId(item) === getItemId(newSelectedItems[i])
                  );
               }
               if (currentIndex === -1) {
                  newChecked.push(item);
               } else {
                  newChecked.splice(currentIndex, 1);
               }
            }
            setChecked(newChecked);
         }
      }
   };
   const handleMouseUp = () => {
      setSelectionStart(null);
   };
   const handleDoubleClick = (item, side) => {
      if (clickTimeout) {
          clearTimeout(clickTimeout);
          clickTimeout = null;
      }
      handleDoubleClickLogic(item, side);
  };
   const handleDoubleClickLogic = (item, side) => {
         const getStartDate = () => {
            if (dayjs(editFromDate).isBefore(dayjs(), 'day')) {
            return dayjs().add(1, 'day').format('YYYY-MM-DD');
            }
            return editFromDate;
         };

         const updatedItem = {
            ...item,
            effectiveStartDate: getStartDate(),  
            effectiveEndDate: editToDate,     
         };
      if (side == "left") {
         dispatch(setCGState(rightState, right.concat(updatedItem)));
         let leftlist = JSON.parse(JSON.stringify(left));
         for (let i = 0; i < leftlist.length; i++) {
            if (getItemId(leftlist[i]) === getItemId(item)) {
               leftlist.splice(i, 1);
            }
         }
         leftlist = leftlist.filter((x) => getItemId(x) != getItemId(item));
         dispatch(setCGState(leftState, leftlist));
         setRight(right.concat(item));
         setLeft(leftlist);
         let checkedlist = JSON.parse(JSON.stringify(checked));
         checkedlist = checkedlist.filter(
            (x) => getItemId(x) != getItemId(item)
         );
         setChecked(checkedlist);
      }
      if (side == "right") {
         dispatch(setCGState(leftState, left.concat(updatedItem)));
         let rightlist = JSON.parse(JSON.stringify(right));
         // for(let i = 0; i< rightlist.length; i++){
         // 	if(getItemId(rightlist[i]) === getItemId(item)){
         // 		rightlist.splice(i,1);
         // 	}
         // }
         rightlist = rightlist.filter((x) => getItemId(x) != getItemId(item));
         dispatch(setCGState(rightState, rightlist));
         setLeft(left.concat(item));
         setRight(rightlist);
         let checkedlist = JSON.parse(JSON.stringify(checked));
         checkedlist = checkedlist.filter(
            (x) => getItemId(x) != getItemId(item)
         );
         setChecked(checkedlist);
      }
   };

   const handleAllRight = () => {
      const tempRight = right.concat(left);
      setRight(tempRight);
      setLeft([]);

      dispatch(setCGState(rightState, tempRight));
      dispatch(setCGState(leftState, []));
   };

   const handleCheckedRight = () => {
      const tempRight = right.concat(leftChecked);
      const tempLeft = not(left, leftChecked);

      setRight(tempRight);
      setLeft(tempLeft);
      setChecked(not(checked, leftChecked));

      dispatch(setCGState(rightState, tempRight));
      dispatch(setCGState(leftState, tempLeft));
   };

   const handleCheckedLeft = () => {
      const tempLeft = left.concat(rightChecked);
      const tempRight = not(right, rightChecked);

      setLeft(tempLeft);
      setRight(tempRight);
      setChecked(not(checked, rightChecked));

      dispatch(setCGState(leftState, tempLeft));
      dispatch(setCGState(rightState, tempRight));
   };

   const handleAllLeft = () => {
      const tempLeft = left.concat(right);
      setLeft(tempLeft);
      setRight([]);

      dispatch(setCGState(leftState, tempLeft));
      dispatch(setCGState(rightState, []));
   };

   const getItemTextForToolTip = (item) => {
      if (item.hasOwnProperty("name")) {
          return item.name + (item['parentName'] == undefined || item['type']=='CG' ? '' : ' ('+ item['parentName'] + ' )' );;
      } else if (item.hasOwnProperty("customerGroupName")) {
          return item.customerGroupName;
      } else if (item.hasOwnProperty("customerName")) {
          return item.customerName + (item['parentName'] == undefined ? '' : ' ('+ item['parentName'] + ' )' );
      }
  };

   function sortbyName(items, side) {
      let list = items.slice();
      list.sort((first, second) => {
         if (first.customerName < second.customerName) return -1;
         if (first.customerName > second.customerName) return 1;
         return 0;
      });
      if (side === "left") {
         dispatch(setCGState("customers", list));
      } else {
         dispatch(setCGState("selCustomers", list));
      }
   }

   function sortbyNumber(items, side) {
      let list = items.slice();
      list.sort((first, second) => {
         if (first.sapCustomerNumber < second.sapCustomerNumber) return -1;
         if (first.sapCustomerNumber > second.sapCustomerNumber) return 1;
         return 0;
      });
      if (side === "left") {
         dispatch(setCGState("customers", list));
      } else {
         dispatch(setCGState("selCustomers", list));
      }
   }

   const handleClick = (type, side) => {
      if (type === "name") {
        if (side === "left") {
          if (!isAscByNameLeft) {
            let list = JSON.parse(JSON.stringify(left));
            list = list.sort((a, b) =>
              getItemText(a).trim() > getItemText(b).trim() ? 1 : -1
            );
            setLeft(list);
            setAscByNameLeft(true);
          } else {
            let list = JSON.parse(JSON.stringify(left));
            list = list.sort((a, b) =>
              getItemText(a).trim() < getItemText(b).trim() ? 1 : -1
            );
            setLeft(list);
            setAscByNameLeft(false);
          }
        } else {
          if (!isAscByNameRight) {
            let list = JSON.parse(JSON.stringify(right));
            list = list.sort((a, b) =>
              getItemText(a).trim() > getItemText(b).trim() ? 1 : -1
            );
            setAscByNameRight(true);
            setRight(list);
          } else {
            let list = JSON.parse(JSON.stringify(right));
            list = list.sort((a, b) =>
              getItemText(a).trim() < getItemText(b).trim() ? 1 : -1
            );
            setAscByNameRight(false);
            setRight(list);
          }
        }
      } else {
        if (side === "left") {
          if (!isAscByNumberLeft) {
            let list = JSON.parse(JSON.stringify(left));
            list = list.sort((a, b) =>
              getItemNumber(a) > getItemNumber(b) ? 1 : -1
            );
            setLeft(list);
            setAscByNumberLeft(true);
          } else {
            let list = JSON.parse(JSON.stringify(left));
            list = list.sort((a, b) =>
              getItemNumber(a) < getItemNumber(b) ? 1 : -1
            );
            setLeft(list);
            setAscByNumberLeft(false);
          }
        } else {
          if (!isAscByNumberRight) {
            let list = JSON.parse(JSON.stringify(right));
            list = list.sort((a, b) =>
              getItemNumber(a) > getItemNumber(b) ? 1 : -1
            );
            setAscByNumberRight(true);
            setRight(list);
          } else {
            let list = JSON.parse(JSON.stringify(right));
            list = list.sort((a, b) =>
              getItemNumber(a) < getItemNumber(b) ? 1 : -1
            );
            setAscByNumberRight(false);
            setRight(list);
          }
        }
      }
    };

   const customList = (items, count, side) => {
      const isItemLoaded = index => !!items[index];
      return (
          <React.Fragment>
              {side === "right" ? (
                  <Box
                     sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: 1,
                        mb: 0.5,
                     }}
                  >
                     <Typography variant="subtitle1">Customer to be assigned</Typography>
                     <Switch
                        color="error"
                        checked={assignSearchFilterEnabled}
                        onChange={(_, v) => setAssignSearchFilterEnabled(v)}
                        inputProps={{
                           "aria-label": "Enable search filter on assigned customers",
                        }}
                        className={switchClass}
                        sx={{
                           transform: "scale(1.35)",
                           transformOrigin: "center",
                        }}
                     />
                  </Box>
              ) : null}
              {side === "left" ? <Typography variant="subtitle1">Search result</Typography> : null}
              {side === "right" ? (
                  <TextField
                     label="Search"
                     size="small"
                     fullWidth
                     value={assignSearchQuery}
                     onChange={(e) => setAssignSearchQuery(e.target.value)}
                     variant="outlined"
                     autoComplete="assign-customer-search"
                     sx={{
                        mt: 1,
                        mb: 0.5,
                        "& .MuiOutlinedInput-root": {
                           "& fieldset": {
                              borderColor: "darkred.light",
                           },
                           "&:hover fieldset": {
                              borderColor: "darkred.main",
                           },
                           "&.Mui-focused fieldset": {
                              borderColor: "darkred.main",
                           },
                        },
                     }}
                  />
              ) : null}
              <Typography sx={{ fontSize: "14px", cursor: "pointer" }}  onClick={() => handleClick("name", side)} display="inline">Sort by Name |</Typography> <Typography sx={{ fontSize: "14px", cursor: "pointer" }} onClick={() => handleClick("number", side)} display="inline">Sort by Number</Typography>
              <Typography sx={{ fontSize: "12px",mt: 1, mb: 1, }} >Count: <b>{count}</b></Typography>
              <Paper className="transferList"
                  sx={{ width: `${boxWidth}vw`, height: 400, overflowX : "none", overflowY: "auto", justifyContent: "space-between", border: "1px solid #c6c6c6" }}
              >
                  <InfiniteLoader itemCount={items.length} isItemLoaded={isItemLoaded}>
                      {({ onItemsRendered, ref }) => (
                          <AutoSizer>
                              {({ height, width }) => (
                                  <List
                                      ref={ref}
                                      height={395}
                                      width={`${boxWidth-0.2}vw`}
                                      itemCount={items.length}
                                      itemSize={listItemHeight}
                                      style={{overflowY: 'auto', overflowX: 'hidden' }}
                                      onItemsRendered={onItemsRendered}>
                                      {({ index, style }) => {
                                          return (

                                              <ListItem
                                                  key={index}
                                                  item={items[index]}
                                                  style={{...style, backgroundColor : checked.includes(items[index]) ? '#f2f1ed' : ''}}
                                                  button
                                                  onClick={(event) => handleToggleWithClick(event, index, items[index], side)}
                                                  //onClick={handleClick}
                                                  onDoubleClick={() => handleDoubleClick(items[index], side)}
                                                  //onMouseDown={(e) => handleMouseDown(e, index)}
                                                  onMouseMove={(e) => handleMouseMove(e, side, index)}
                                                  onMouseUp={handleMouseUp}
                                              >
                                                  <ListItemIcon>
                                                      <Checkbox
                                                          checked={checked.indexOf(items[index]) !== -1}
                                                          onClick={(event) => handleToggle(event, index, items[index], side)}
                                                          tabIndex={-1}
                                                          disableRipple
                                                      />
                                                  </ListItemIcon>
                                                  <Tooltip
                                                      title={getItemTextForToolTip(items[index])}
                                                      sx={{
                                                         "& .MuiTooltip-tooltip": {
                                                         fontSize: "1rem",
                                                         padding: "10px 20px",
                                                         },
                                                      }}
                                                   >
                                                  <ListItemText
                                                     id={index}
                                                     primary={
                                                        <Highlighter
                                                           highlightClassName="highlight"
                                                           highlightStyle={{ backgroundColor: "yellow" }}
                                                           searchWords={
                                                              side === "right"
                                                                 ? assignSearchHighlightWords
                                                                 : []
                                                           }
                                                           autoEscape={true}
                                                           textToHighlight={String(
                                                              getItemText(items[index]) ?? ""
                                                           )}
                                                        />
                                                     }
                                                     className={
                                                        items[index]?.active === "N"
                                                           ? "red-text"
                                                           : items[index]?.stqColor === "Y"
                                                           ? "blue-text"
                                                           : ""
                                                     }
                                                  />
                                                </Tooltip>
                                              </ListItem>
                                          );
                                      }}
                                  </List>
                              )}
                          </AutoSizer>
                      )}
                  </InfiniteLoader>
              </Paper>
          </React.Fragment>
      );

  }

   return (
      <Grid
         container
         spacing={2}
         justifyContent="space-between"
         alignItems="center"
      >
         <Grid item>{customList(left, countLeft, "left")}</Grid>
         <Grid item>
            <Grid container direction="column" alignItems="center">
               <Button
                  sx={{ 
                     my: 0.5,
                     color: "darkred.light",
                     bgcolor: "grey.lighter",
                     width:"100%",
                     border:"none",
                     "&:hover": {
                       bgcolor: "darkred.main",
                       color: "white.main",
                       border:"none",
                     },
                    }}
                  variant="outlined"
                  size="small"
                  onClick={handleAllRight}
                  disabled={left.length === 0}
                  aria-label="move all right"
               >
                  {addAllBtnText}
               </Button>
               <Button
                   sx={{ 
                     my: 0.5,
                     color: "darkred.light",
                     bgcolor: "grey.lighter",
                     width:"100%",
                     border:"none",
                     "&:hover": {
                       bgcolor: "darkred.main",
                       color: "white.main",
                       border:"none",
                     },
                    }}
                  variant="outlined"
                  size="small"
                  onClick={handleCheckedRight}
                  disabled={leftChecked.length === 0}
                  aria-label="move selected right"
               >
                  {addBtnText}
               </Button>
               <Button
                  sx={{ 
                     my: 0.5,
                     color: "darkred.light",
                     bgcolor: "grey.lighter",
                     width:"100%",
                     border:"none",
                     "&:hover": {
                       bgcolor: "darkred.main",
                       color: "white.main",
                       border:"none",
                     },
                    }}
                  variant="outlined"
                  size="small"
                  onClick={handleCheckedLeft}
                  disabled={rightChecked.length === 0}
                  aria-label="move selected left"
               >
                  {remBtnText}
               </Button>
               <Button
                    sx={{ 
                     my: 0.5,
                     color: "darkred.light",
                     bgcolor: "grey.lighter",
                     width:"100%",
                     border:"none",
                     "&:hover": {
                       bgcolor: "darkred.main",
                       color: "white.main",
                       border:"none",
                     },
                    }}
                  variant="outlined"
                  size="small"
                  onClick={handleAllLeft}
                  disabled={right.length === 0}
                  aria-label="move all left"
               >
                  {remAllBtnText}
               </Button>
            </Grid>
         </Grid>
         <Grid item>{customList(rightView, rightView.length, "right")}</Grid>
      </Grid>
   );
}
